import '../styles/spinner.scss';

export const renderSpinner = () => {
  const spinnerContainer = document.createElement('div');
  spinnerContainer.id = 'brand-registry-header-spinner';
  spinnerContainer.className = 'brand-registry-header-spinner';

  const circularWrapper = document.createElement('div');
  circularWrapper.className = 'brand-registry-header-spinner-circular-wrapper';

  const circularSvgIconWrapper = document.createElement('div');
  circularSvgIconWrapper.className = 'brand-registry-header-spinner-circular-svg-icon-wrapper';

  const circularSvgWrapper = document.createElement('div');
  circularSvgWrapper.className = 'brand-registry-header-spinner-circular-svg-wrapper';
  circularSvgWrapper.innerHTML = `
    <svg viewBox="0 0 20 20" class="brand-registry-header-spinner-indeterminate">
        <path
          d="M9 1 A9 9 0 1 1 1 9"
          stroke-linecap="round"
          class="brand-registry-header-spinner-meter"
        />
    </svg>
  `;

  circularSvgIconWrapper.appendChild(circularSvgWrapper);
  circularWrapper.appendChild(circularSvgIconWrapper);

  spinnerContainer.appendChild(circularWrapper);
  return spinnerContainer;
};
